import { FC } from 'react';
import { Container } from '@/components/ui/Container';
import { Card } from '@/components/ui/Card';

const testimonials = [
  {
    id: 1,
    company: '某知名互联网公司',
    industry: '互联网',
    teamSize: '50-100人',
    plan: 'MaxPlus版',
    avatar: '🏢',
    testimonial: '使用白茆AI后，我们团队的代码审查效率提升了60%，bug发现率提高了40%。特别是在重构老旧代码时，AI给出的建议非常精准。',
    results: {
      efficiency: '60%',
      bugReduction: '40%',
      satisfaction: '95%'
    },
    contact: '技术总监 张先生'
  },
  {
    id: 2,
    company: '独立软件开发者',
    industry: '个人开发',
    teamSize: '个人',
    plan: 'Max版',
    avatar: '👨‍💻',
    testimonial: '作为个人开发者，白茆AI就像我的编程伙伴。无论是新技术学习还是项目开发，都能提供很好的帮助，大大节省了我的开发时间。',
    results: {
      timeReduction: '50%',
      productivity: '80%',
      learning: '快速'
    },
    contact: '全栈工程师 李女士'
  },
  {
    id: 3,
    company: '某金融科技公司',
    industry: '金融科技',
    teamSize: '100-200人',
    plan: 'MaxPlus版',
    avatar: '🏦',
    testimonial: '在金融级的代码质量要求下，白茆AI帮助我们保持了高标准的代码规范，同时显著提升了开发效率。安全性和准确性都让我们很满意。',
    results: {
      quality: '95%',
      compliance: '100%',
      efficiency: '45%'
    },
    contact: '架构师 王先生'
  }
];

export const TestimonialSection: FC = () => {
  return (
    <section className="py-20 bg-white">
      <Container>
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            用户怎么说
          </h2>
          <p className="text-xl text-gray-600">
            已有1000+开发者选择白茆AI，听听他们的真实体验
          </p>
        </div>
        
        {/* User Distribution */}
        <div className="flex justify-center items-center space-x-8 mb-16 text-center">
          <div>
            <div className="text-2xl font-bold text-primary-600">45%</div>
            <div className="text-gray-600 text-sm">企业用户</div>
          </div>
          <div>
            <div className="text-2xl font-bold text-accent-500">35%</div>
            <div className="text-gray-600 text-sm">个人开发者</div>
          </div>
          <div>
            <div className="text-2xl font-bold text-warning-500">20%</div>
            <div className="text-gray-600 text-sm">学生用户</div>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <Card key={testimonial.id} className="h-full">
              <div className="flex items-center mb-4">
                <div className="text-3xl mr-3">{testimonial.avatar}</div>
                <div>
                  <h3 className="font-semibold text-gray-900">{testimonial.company}</h3>
                  <p className="text-sm text-gray-600">
                    {testimonial.industry} • {testimonial.teamSize} • {testimonial.plan}
                  </p>
                </div>
              </div>
              
              <blockquote className="text-gray-700 mb-6 leading-relaxed italic">
                "{testimonial.testimonial}"
              </blockquote>
              
              <div className="grid grid-cols-2 gap-4 mb-4 p-4 bg-gray-50 rounded-lg">
                {Object.entries(testimonial.results).map(([key, value]) => (
                  <div key={key} className="text-center">
                    <div className="text-lg font-bold text-primary-600">{value}</div>
                    <div className="text-xs text-gray-600">
                      {key === 'efficiency' && '效率提升'}
                      {key === 'bugReduction' && 'Bug减少'}
                      {key === 'satisfaction' && '满意度'}
                      {key === 'timeReduction' && '时间节省'}
                      {key === 'productivity' && '生产力提升'}
                      {key === 'learning' && '学习速度'}
                      {key === 'quality' && '代码质量'}
                      {key === 'compliance' && '合规性'}
                    </div>
                  </div>
                ))}
              </div>
              
              <cite className="text-sm text-gray-500 not-italic">
                — {testimonial.contact}
              </cite>
            </Card>
          ))}
        </div>
      </Container>
    </section>
  );
};